module.exports = __webpack_public_path__ + "img/en-3-3.fbde4648.png";